const faqs = [
  {
    q: '开运体育平台提供哪些服务？',
    a: '开运体育平台提供体育资讯、赛事预测、竞技分析、运动健康指导等全方位服务。无论您是关注足球、篮球、电竞还是其他体育项目，都能在这里找到专业的内容。',
  },
  {
    q: '开运体育的赛事预测准确吗？',
    a: '开运体育拥有50余位专业体育分析师团队，运用大数据分析和专业经验进行赛事预测，历史预测准确率高达98%，在行业内处于领先水平。',
  },
  {
    q: '如何在开运体育获取最新赛事资讯？',
    a: '您可以通过开运体育官网浏览最新资讯，我们的编辑团队7x24小时跟踪全球体育赛事动态，确保您第一时间获取重要赛事信息和分析解读。',
  },
  {
    q: '开运体育的运动健康内容适合普通人吗？',
    a: '是的，开运体育的运动健康板块涵盖了从入门到专业的内容，无论是运动新手还是资深健身爱好者，都能找到适合自己的训练指导和营养建议。',
  },
  {
    q: '开运体育平台是否收费？',
    a: '开运体育平台的基础内容完全免费开放。我们致力于让每一位体育爱好者都能获取优质、专业的体育资讯和分析服务。',
  },
];

export default function FAQSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            关于开运体育
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="font-heading text-sm font-semibold text-foreground-900 pr-4">{faq.q}</span>
                <i className="ri-add-line text-foreground-400 group-open:hidden shrink-0"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}